// Module
var code = `<!--


    <h3 class="text text-{{menuData.levelType}}">{{title}}</h3>
    <h5 class="text text-{{menuData.levelType}}">{{subtitle}}</h5>
    <p class="text text-{{menuData.levelType}}">{{text}}</p>

-->
<div class="breadcrumb-holder"></div>
<div class="page-content page-docs-content"></div>

<!--
<div class="docs-content">
    <h1>QUICK START GUIDE</h1>

    <h3>How to use this guide</h3>
    <div>This quick start guide will focus on the very basics of creating a spyne application. You can following along with the online examples below. And if you'd like you can download and play around with one of the following spyne applications:

    </div>






    <div class="doc-intro doc-type-quick-start">
        <h1><span>Getting Started:</span> Create a Spyne Application</h1>

    </div>

    <article class="doc-item">
        <h2>Spyne Application Generator</h2>

        <h3>Create a single-page-application with a few clicks at <a href="//generator.spynejs.org" target="_blank">https://generator.spynejs.org</a></h3>
        <p>The quickest way to create a single-page-application is to use the <a href="//generator.spynejs.org" target="blank">Spyne Application Generator</a></p>
    </article>

   <article class="doc-item">
        <h2>Hello World App</h2>
        <p>The quickest way to create a single-page-application is to use the <a href="//generator.spynejs.org" target="blank">Spyne Application Generator</a></p>

    </article>

    <div class="doc-intro doc-type-quick-start">
        <h1><span>Getting Started:</span> Start from Scratch</h1>
    </div>

    <article class="doc-item">
        <div class="doc-item-desc">
        <h3>Create a ViewStream object</h3>
        <p>Creating a view in spyne should look familiar to most frontend developers:</p>
        </div>
        <div class="code-example code-iframe">






           <iframe src="//stackblitz.com/edit/js-dhecem?embed=1&file=index.js&hideExplorer=1&hideNavigation=1&theme=dark"></iframe>


            <iframe src="https://codesandbox.io/embed/determined-ramanujan-g51s5?fontsize=14&hidenavigation=1&theme=light"
                    style="width:100%; height:200px; border:0; border-radius: 4px; overflow:hidden;"
                    title="spynejs-hello-world"
                    allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking"
                    sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
            ></iframe>

            <div class="doc-item-desc">

                <p>Spyne’s rendering of View class, ViewStream, is simple by design, and is used to declare properties and attributes.</p>
                <p>ViewStreams are a pure javascript class that is meant to be extended. The Views properties, classes and attributes are declared in the constructor.<p>
                <p>Once the View is added to the dom, the <i>onRendered</i> method is called.</p>
                <p>But ViewStreams are have many unique features. Two main features are its ability to<ol>
                <li>Intuitve pure javascript system to instantly create and destroy dom branches</li>
            <li>The wiring of events, data and route actions to local methods</li>
            </ol></p>

                <p>This second feature is what really makes Spyne unique makes building advanced applications much easier</p>
                <p>To understand those features it will help to first go over what really is different about Spyne when compared to other frameworks.</p>


                <p>Where Spyne differs from other frameworks is in the way it handles events, data and routes.</p>
                <p>It helps to understand how ViewStreams work by going overe the object that powers Spyne's views, <i>Channels</i>.</p>
                <p>Let's go over Channels now since they are what powers any Spyne application</p>
                <div class="callout"><p>ViewStreams have many features and options that are discussed in greater detail in the overview and references sections of this website.</p></div>
            </p>


            </div>
        </div>

    </article>

    <article class="doc-item">
        <div class="doc-item-desc">
        <h3>Events, Data and Routes</h3>


            <p>
                Events, Data and Routes are defined as observables called <b>Channels</b>.
                Channels output a consistent Channel Payload format that includes an action script and a data object called the <i>payload</i>.
                View the output by click the following buttons or by accessing the channel console plugin below.
            </p>
        </div>
        <div class="code-example code-iframe">

            <iframe src="https://codesandbox.io/embed/sypnejs-channel-fetch-ltlfk?fontsize=14&hidenavigation=1&theme=dark"
                    style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;"
                    title="sypnejs-channel-fetch"
                    allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking"
                    sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
            ></iframe>


           <iframe style="min-height: 420px;" src="//stackblitz.com/edit/js-2ylqov?embed=1&file=index.js&view=both"></iframe>



        </div>

    </article>

    <article class="doc-item">
        <h2>Render a ViewStream object</h2>
        <p>The quickest way to create a single-page-application is to use the <a href="//generator.spynejs.org" target="blank">Spyne Application Generator</a></p>

    </article>

    <article class="doc-item">
        <h2>spyne-cli</h2>
        <p>The quickest way to create a single-page-application is to use the <a href="//generator.spynejs.org" target="blank">Spyne Application Generator</a></p>
        <div class="code-snippet">
            <button class="btn-copy" data-clipboard-text="npm install -g spyne-cli">

                <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 100 100" x="0px" y="0px"><title>04</title><g data-name="Group"><path data-name="Compound Path" d="M25.1,82.7H62.9a10,10,0,0,0,10-10V39.3a10,10,0,0,0-10-10H25.1a10,10,0,0,0-10,10V72.7A10,10,0,0,0,25.1,82.7Zm-6-43.4a6,6,0,0,1,6-6H62.9a6,6,0,0,1,6,6V72.7a6,6,0,0,1-6,6H25.1a6,6,0,0,1-6-6Z"></path><path data-name="Path" d="M84.9,67V29.3a12,12,0,0,0-12-12H30.7a2,2,0,0,0,0,4H72.9a8,8,0,0,1,8,8V67a2,2,0,0,0,4,0Z"></path></g></svg>


            </button>
            <pre>npm install -g spyne-cli</pre>

        </div>

    </article>

</div>
-->
`;
// Exports
module.exports = code;